import { useNavigate } from 'react-router-dom';
import { openCustomerService } from '@/lib/customerService';

export default function ForgotPassword() {
  const navigate = useNavigate();

  const openSupport = () => {
    openCustomerService('forgot-password');
  };

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-6">
        <div className="text-center mb-7">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mx-auto mb-3">
            <i className="ri-shield-keyhole-line text-white text-2xl" />
          </div>
          <h1 className="text-xl font-bold text-foreground-950">安全找回账号</h1>
          <p className="text-sm text-foreground-500 mt-1">客服核验身份后为您重置密码</p>
        </div>

        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 mb-5">
          <div className="flex items-start gap-3">
            <i className="ri-lock-2-line text-amber-600 text-lg mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-amber-900">不支持仅凭账号直接修改密码</p>
              <p className="text-xs text-amber-800/80 leading-relaxed mt-1">
                为防止账号被他人冒用，用户名账号必须由官方客服核验注册域名、历史 UID 或渠道信息后处理。
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-start gap-3 rounded-xl bg-white border border-background-200 p-3.5">
            <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex items-center justify-center shrink-0">1</span>
            <p className="text-sm text-foreground-600 leading-relaxed">准备您的登录账号和当前注册域名</p>
          </div>
          <div className="flex items-start gap-3 rounded-xl bg-white border border-background-200 p-3.5">
            <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex items-center justify-center shrink-0">2</span>
            <p className="text-sm text-foreground-600 leading-relaxed">联系客服完成身份与账号归属核验</p>
          </div>
          <div className="flex items-start gap-3 rounded-xl bg-white border border-background-200 p-3.5">
            <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex items-center justify-center shrink-0">3</span>
            <p className="text-sm text-foreground-600 leading-relaxed">核验通过后由客服执行安全重置</p>
          </div>
        </div>

        <button
          type="button"
          onClick={openSupport}
          className="w-full py-3 bg-[#07c160] text-white rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap"
        >
          <i className="ri-customer-service-2-line mr-1.5" />
          联系官方客服
        </button>

        <p className="text-xs text-foreground-400 text-center leading-relaxed mt-4">
          已绑定手机号的老用户，也可由客服引导使用原短信验证流程。
        </p>

        <button
          type="button"
          onClick={() => navigate('/login')}
          className="mt-5 text-primary-500 text-sm font-medium cursor-pointer"
        >
          返回登录
        </button>
      </div>
    </div>
  );
}
